import styled, { createGlobalStyle } from 'styled-components';

export const GlobalStyles = createGlobalStyle`
  header {
    display: none;
  }
  footer {
    display: none;
  }
`;

export const Container = styled.div`
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 50px;
  margin: auto;
  width: 90%;
  max-width: 990px;
`;

const font = `
  font-family: HelveticaNeue, Arial, sans-serif;
  font-size: 30px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.27;
  letter-spacing: 0.5px;
  text-align: center;
  color: #000;
  @media (max-width: 992px) {
    font-size: 17px;
  }
`;

export const Title = styled.h1`
  ${font}
  font-size: 60px;
  letter-spacing: 1px;
  @media (max-width: 992px) {
    font-size: 34px;
  }
`;

export const Text = styled.p`
  ${font}
`;

export const Restart = styled.button`
  ${font}
  font-weight: bold;
  border: none;
  background: none;
  outline: none;
  text-decoration: underline;
  cursor: pointer;
  &:disabled {
    text-decoration: none;
    cursor: auto;
  }
`;
